/**
 * Temporary V1.1 LXN HQ app mark.
 * Minimal geometric line glyph that subtly hints at L/X/N without spelling it out.
 * Designed to be replaced by a custom SVG later.
 */
export function AppMark({ size = 20, className = "", stroke = "currentColor" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Vertical stroke (L stem) */}
      <path d="M5 3 L5 21" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
      {/* Diagonal strokes (X crossing) */}
      <path d="M5 21 L19 3" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M9 8 L19 21" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
      {/* Small dot / anchor */}
      <circle cx="19" cy="3" r="1" fill={stroke} />
    </svg>
  );
}

/** Branded tile — used as sidebar / login header logo box. */
export function AppMarkTile({ className = "" }) {
  return (
    <div className={`w-10 h-10 rounded-xl bg-[#141416] border border-white/10 flex items-center justify-center text-violet-400 ${className}`}>
      <AppMark size={20} stroke="currentColor" />
    </div>
  );
}
